import { connect } from "react-redux";

import AllDataSection from "../../components/sections/all_data_section";

const mapStateToProps = (state) => {
  const isLoading = state.main.loading.tabIsLoading;

  return { isLoading };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AllDataSection);
